// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"15":"lang-fr-json","124":"lang-en-json","961":"lang-nl-json"}[chunkId] || chunkId) + "." + {"15":"7cb80bc3dc479d3aca94","124":"e79007959f912b7f646e","450":"adaab54567cc67a53673","670":"bfac2db6105e627d38cd","818":"2466ebf6df808f143579","911":"9a1e7389799b1a022e42","961":"6202126e8a80b86c512e"}[chunkId] + ".js";
};